// extracted by mini-css-extract-plugin
export default {"detail_textArea":"SingleLead_detail_textArea__9Aqkq","select":"SingleLead_select__KT4YV","input":"SingleLead_input__FaKYJ","dropdown":"SingleLead_dropdown__Ni6i1"};